import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import Button from "@irati/ui/src/Button"

const Wrapper = styled.div`
  height: ${({theme}) => theme.spacing.five};
  &:last-of-type {
    padding-bottom: ${({theme}) => theme.spacing.two};
  }
  button {
    margin: ${({theme}) => theme.spacing.two};
    margin-bottom: 0;
  }
`

export const ListItem = ({label, item, onClick}) => {
  return (
    <Wrapper>
      <Button tertiary onClick={onClick} isDisabled={!item.action}>{label}</Button>
    </Wrapper>
  )
}

export default ListItem

ListItem.defaultProps = {
  action: null
}

ListItem.propTypes = {
  label: PropTypes.string.isRequired,
  action: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ]),
  item: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired
}
